export { default } from "@casino/legacy/client/components/Game/hooks/useNotificationStore";
